/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `0` - Taxable
* `1` - Non-taxable
* `2` - Untaxable
* `3` - Tax exemption
 */
export type TaxClassEnum = typeof TaxClassEnum[keyof typeof TaxClassEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaxClassEnum = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;
